module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "fmad",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c7#ack1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', {
    staticClass: "tx1"
  }, [_vm._v("I’d like to thank the following people who have given me help of one kind or another while I was writing this book:")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angela Hendrix, Kathleen Kern, Barbara Kingsbury, Andrew Langman, Travis MacCaskill, Faith Manney, Patricia Pelrine, Charles Rhyne, Nancy Santos, Marion Scepansky, Dave Snyder, Michael Taeckens, Jim Teal, and Nathan Watters.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e85ca27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c8.vue
// module id = 75
// module chunks = 0